module.exports = __webpack_public_path__ + "static/media/r328.c454a35b.jpg";